<template>
  <div class="projects-container container-fluid">
    <Suspense>
      <template #default>
        <router-view></router-view>
      </template>

      <template #fallback>
        <div>Loading all projects...</div>
      </template>
    </Suspense>
  </div>
</template>

<script setup lang="ts">
//import ProjectsTable from './List.vue';
</script>
